import { create } from 'zustand'

export interface Notification {
  id: string
  type: 'success' | 'error' | 'warning' | 'info'
  content: string
  dismissible?: boolean
}

interface NotificationState {
  items: Notification[]
  add: (item: Omit<Notification, 'id'> & { id?: string }) => void
  dismiss: (id: string) => void
  clear: () => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  add: (item) => {
    const id = item.id ?? crypto.randomUUID()
    set((s) => ({
      items: [
        ...s.items.filter((n) => n.id !== id),
        { ...item, id, dismissible: item.dismissible ?? true },
      ],
    }))
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((n) => n.id !== id) })),
  clear: () => set({ items: [] }),
}))
